import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import "./themes/index.css";
import defaultTheme from "./themes";
import WebFont from "webfontloader";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { CounterProvider } from "./context/reducer";
import { store, persistor } from "./store/reducers/reducerIndex";
import { LoaderProvider } from "./context/LoaderContext";

WebFont.load({
	google: {
		families: ["Lato", "sans-serif", "Roboto", "sans-serif"],
	},
});

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter>
				<ThemeProvider theme={defaultTheme}>
					<CssBaseline />
					<CounterProvider>
						<LoaderProvider>
						<App />
						</LoaderProvider>
					</CounterProvider>
				</ThemeProvider>
			</BrowserRouter>
		</PersistGate>
	</Provider>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
